import { render, staticRenderFns } from "./SpecialtyInformation.vue?vue&type=template&id=f0363cc2&"
import script from "./SpecialtyInformation.vue?vue&type=script&lang=js&"
export * from "./SpecialtyInformation.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports